import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ExceptionHelper } from '../../../../helper';
import { DangerModalComponent } from '../../../shared/components/danger-modal/danger-modal.component';
import { SuccessModalComponent } from '../../../shared/components/success-modal/success-modal.component';
import { WarningModalComponent } from '../../../shared/components/warning-modal/warning-modal.component';
import { ServiceCallService } from '../service-call.service';

@Component({
  selector: 'app-service-call-pdf-summary',
  templateUrl: './service-call-pdf-summary.component.html',
  styleUrls: ['./service-call-pdf-summary.component.css']
})
export class ServiceCallPdfSummaryComponent implements OnInit {

  id = '';
  files: any[];
  dataTable: any;
  bsModalRef: BsModalRef;
  isDownloading = false;

  constructor(
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private router: Router,
    private chRef: ChangeDetectorRef,
    private exception: ExceptionHelper,
    private serviceCallService: ServiceCallService,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en-us');
    this.route.params.subscribe(params => {
      this.id = params['id'];
      console.log(params);

    });
  }

  ngOnInit() {
    this.getEquipmentDetail();
  }

  getEquipmentDetail() {
    this.serviceCallService.getPDFs(this.id).subscribe(res => {
      this.files = res.SpeicalServiceReportsList;
    }, err => {
        this.files = [];
      }, () => {
        if ($.fn.dataTable.isDataTable('#pdfDataTable')) {
          $('#pdfDataTable').DataTable().destroy();
        }
  
        this.chRef.detectChanges();
        const table: any = $('#pdfDataTable');
        table.DataTable();
      });
    }
    
  download(fileId) {
    this.isDownloading = true;

    this.serviceCallService.downloadServiceReport(fileId).subscribe(data => {
      const blob = new Blob([data.file], { type: 'application/pdf' });
      saveAs(blob, data.fileName);
      this.isDownloading = false;
    }, error => {
      this.isDownloading = false;
      this.exception.showError(error, 'showDanModalBtn');
      // this.redirect = false;
    });
  }
  delete(fileId) {

    const initialState = {
      message: this.translate.instant('header.pdf'),
      ok: () => {
        this.serviceCallService.deletePDF(this.id, fileId).subscribe(res => {
          this.bsModalRef.hide();
          const initialState = {
            message: this.translate.instant('header.pdf'),
            type: 3,
            ok: () => {
              this.bsModalRef.hide();
              this.router.navigate([''], {skipLocationChange: true}).then(
                x => this.router.navigate(['/home/e-call/pdf/', this.id])
              )
            }
          };
          this.bsModalRef = this.modalService.show(SuccessModalComponent, { initialState });
            
        }, err => {
          console.log(err);
          const initialState = {
            message: err.error.message || this.translate.instant('msg.error'),
            ok: () => {
              this.bsModalRef.hide();
            }
          };
          this.bsModalRef = this.modalService.show(DangerModalComponent, { initialState })
        })
      }
    };
    this.bsModalRef = this.modalService.show(WarningModalComponent, { initialState });

  }


}


// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/service-call/service-call-pdf-summary/service-call-pdf-summary.component.ts